export default "__VITE_ASSET__BbCouEH3__"